module.exports = __webpack_public_path__ + "static/img/chaichu1.391baa28.jpg";